export default "__VITE_ASSET__5ZPoOWrT__"